import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private static promise: Promise<void> | null = null;

  /**
   * Carrega a API do Google Maps dinamicamente (apenas uma vez).
   * Retorna uma Promise que resolve quando a API estiver pronta.
   */
  load(): Promise<void> {
    if (GoogleMapsLoaderService.promise) {
      return GoogleMapsLoaderService.promise;
    }

    // Se já estiver carregada (ex: via script tag no index.html)
    if (typeof google !== 'undefined' && google.maps) {
      GoogleMapsLoaderService.promise = Promise.resolve();
      return GoogleMapsLoaderService.promise;
    }

    GoogleMapsLoaderService.promise = new Promise<void>((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&loading=async&libraries=maps`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => {
        GoogleMapsLoaderService.promise = null;
        reject(new Error('Falha ao carregar a API do Google Maps'));
      };
      document.head.appendChild(script);
    });

    return GoogleMapsLoaderService.promise;
  }
}
